import api from "./http-common";
import axiosInstance from "./axiosInstance";
import { getUserInfoDetails } from "../utlis";

// Safe integer ID validation
const validateId = (id, name = 'ID') => {
  const parsed = parseInt(id, 10);
  if (isNaN(parsed) || parsed <= 0) throw new Error(`Invalid ${name}`);
  return parsed;
};

// POST Request

export const createAccount = async (data) => {
  let response;

  try {
    response = await api.post("endpoint", data);
    return response;
  } catch (error) {
    return error;
  }
};


export const createUser = async (userData) => {
  return axiosInstance.post('/user', userData);
};

export const createUserRole = async (roleData) => {
  return axiosInstance.post('/roles', roleData);
};

export const getUsersList = async (pageNum, pageSize, status) => {
  let url = `/users?pageNum=${pageNum}&pageSize=${pageSize}`;
  if (status) url += `&status=${status}`;
  return axiosInstance.get(url);
};

export const getAccountsList = async (pageNum, pageSize) => {
  return axiosInstance.get(`/accounts?pageNum=${pageNum}&pageSize=${pageSize}`);
};

export const getUserRolesList = async (pageNum, pageSize) => {
  return axiosInstance.get(`/user-roles?pageNum=${pageNum}&pageSize=${pageSize}`);
};

// User APIs
export const updateUser = async (userId, userData) => {
  const safeId = validateId(userId, 'userId');
  return axiosInstance.put(`/user/${safeId}`, userData);
};

export const getRoles = async (pageNum = 1, pageSize = 100) => {
  return axiosInstance.get(`/roles?pageNum=${pageNum}&pageSize=${pageSize}`);
};

export const updateUserRole = async (roleId, roleData) => {
  const safeId = validateId(roleId, 'roleId');
  return axiosInstance.put(`/roles/${safeId}`, roleData);
};

// Client/Account APIs
export const getAllClients = async (pageNum = 1, pageSize = 100) => {
  return axiosInstance.get(`/clients?pageNum=${pageNum}&pageSize=${pageSize}`);
};

export const createClient = async (clientData) => {
  return axiosInstance.post('/clients', clientData);
};

export const updateClient = async (clientId, clientData) => {
  const safeId = validateId(clientId, 'clientId');
  return axiosInstance.put(`/clients/${safeId}`, clientData);
};

// Config APIs
export const getAllConfigs = async (pageNum = 1, pageSize = 100, type = null) => {
  let url = `/configs?pageNum=${pageNum}&pageSize=${pageSize}`;
  if (type) {
    url += `&type=${type}`;
  }
  return axiosInstance.get(url);
};

export const updateConfig = async (configId, payload) => {
  const safeId = validateId(configId, 'configId');
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.put(`/configs/${safeId}?client=${clientId}&company=${companyId}`, payload);
};

export const createConfig = async (payload) => {
  return axiosInstance.post('/config', payload);
};

export const getUserPreferences = async (prefType) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/config?client=${clientId}&company=${companyId}&type=${prefType}`);
};

// Company APIs
export const getAllCompanies = async (clientUid, pageNum = 1, pageSize = 100) => {
  return axiosInstance.get(`/companies?client_uid=${clientUid}&pageNum=${pageNum}&pageSize=${pageSize}`);
};

export const createCompany = async (companyData) => {
  return axiosInstance.post('/companies', companyData);
};

export const updateCompany = async (companyId, companyData) => {
  const safeId = validateId(companyId, 'companyId');
  return axiosInstance.put(`/companies/${safeId}`, companyData);
};
